import { jsx as o } from "react/jsx-runtime";
import r from "react";
const e = r.createContext({});
function a() {
  return r.useContext(e);
}
function l(n) {
  const {
    children: t,
    ...u
  } = n;
  return /* @__PURE__ */ o(e.Provider, { value: u, children: t });
}
const c = {};
l.Reset = function({
  children: t
}) {
  return /* @__PURE__ */ o(e.Provider, { value: c, children: t });
};
export {
  l as Style,
  a as useContextualStyle
};
